import React from 'react';
// import { axiosAuthFetch } from '../../helpers/apiActions/authFetch';
import serviceCard from './serviceCards.module.css'
import FormModal from '../formModal';
// import CustomButton from '../customButton';
import ServiceForm from '../serviceForm';

export function ServiceCards({ product }) {

    const {name, varenummer, image, visible} = product.attributes;

    const supplier = product.attributes.supplier.data.attributes.name;

    const cardClassName = visible === false ? `${serviceCard.card} ${serviceCard.hidden}` : serviceCard.card;

    return(
        <div className="">
            <div className={cardClassName}>
                {/* <div className="col-12">
                    <Image className={productCard.cardImage} src={image.data.attributes.url} fluid alt={name}/>
                </div> */}
                    <div className={serviceCard.imageContainer} 
                        style={{
                            backgroundImage: `url(${image.data.attributes.url})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'contain',
                            width: '10em',
                            height: '10em',
                        }}
                    />
                <div className="">
                    <div className={serviceCard.produktNavn}>
                        {name}
                    </div>
                    <div className="mt-auto">
                        <p>fra {supplier}</p>
                    </div>
                    <div className="mt-auto">
                        VN: {varenummer}
                    </div>
                    <div className="text-center mt-auto">
                        <FormModal 
                            buttonTitle="Rediger service-skjema" 
                            modalTitle="Rediger service-skjema" 
                            body={<ServiceForm
                                product={product} />}
                            openButtonClass={serviceCard.cardButton2} 
                            closeButtonClass={serviceCard.closeButton}
                        />
                    </div>
                </ div>
            </ div>
        </div>
    )
}

export default ServiceCards;